<ng-template let-extraClass="extraClass" #topNav>
  @if (!windowService.isDesktopRes) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Create Booking Link'"
      [canGoBack]="true" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>
    <ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'desktop' }" />

    @if (isLoading) {
      <tidy-row>
        <ion-skeleton-text
          animated="true"
          style="height: 36px; border-radius: 6px;" />
      </tidy-row>
      <tidy-row class="extra-top-padding">
        <ion-skeleton-text
          animated="true"
          style="height: 36px; border-radius: 6px;" />
      </tidy-row>
      <tidy-row class="extra-top-padding">
        <ion-skeleton-text
          animated="true"
          style="height: 36px; border-radius: 6px;" />
      </tidy-row>
    }

    @if (!isLoading && config && !link) {
      <tidy-row [align]="'center'">
        <tidy-text [helper]="'Offer a guest specific dates at your own price. They book instantly from the link — no approval step.'" />
      </tidy-row>

      <tidy-row class="extra-top-padding">
        <tidy-daterange
          [label]="'Dates'"
          [icon]="'assets/svg/calendar.svg'"
          [dateRangeForm]="dateRangeForm"
          [fieldStyle]="true"
          [dateFilter]="dateFilter"
          [submitted]="submitted"
          (customDateOption)="onDateRange($event)" />
      </tidy-row>
      @if (dateError) {
        <tidy-row>
          <tidy-text [helper]="dateError" class="red" />
        </tidy-row>
      }

      <form [formGroup]="form" novalidate>
        <tidy-row class="extra-top-padding">
          <tidy-input
            [label]="'Price for the stay'"
            [icon]="'assets/svg/cash.svg'"
            [type]="'number'"
            formControlName="price"
            [form]="form.controls.price"
            [submitted]="submitted"
            [errorMessage]="'Please enter a price.'" />
        </tidy-row>
        @if (standardPriceCents !== null) {
          <tidy-row>
            <tidy-text
              [helper]="'Standard price for these dates: ' + (standardPriceCents / 100 | currency)"
              [translate]="false" />
          </tidy-row>
        }
        @if (priceWarning) {
          <tidy-row>
            <tidy-text [helper]="priceWarning" [translate]="false" class="red" />
          </tidy-row>
        }

        <tidy-row class="extra-top-padding">
          <tidy-input
            [label]="'Security deposit'"
            [icon]="'assets/svg/cash.svg'"
            [type]="'number'"
            formControlName="securityDeposit"
            [form]="form.controls.securityDeposit"
            [submitted]="submitted" />
        </tidy-row>
        <tidy-row>
          <tidy-text [helper]="'Refundable. Leave blank for no deposit.'" />
        </tidy-row>

        <tidy-row class="extra-top-padding">
          <tidy-input
            [label]="'Guest name (optional)'"
            formControlName="guestName"
            [form]="form.controls.guestName"
            [submitted]="submitted" />
        </tidy-row>

        <tidy-row class="extra-top-padding">
          <tidy-input
            [label]="'Adults (optional)'"
            [type]="'number'"
            formControlName="adults"
            [form]="form.controls.adults"
            [submitted]="submitted" />
        </tidy-row>

        <tidy-row class="extra-top-padding">
          <tidy-input
            [label]="'Children (optional)'"
            [type]="'number'"
            formControlName="children"
            [form]="form.controls.children"
            [submitted]="submitted" />
        </tidy-row>

        <tidy-row class="extra-top-padding">
          <tidy-input
            [label]="'Note to the guest (optional)'"
            formControlName="note"
            [form]="form.controls.note"
            [submitted]="submitted" />
        </tidy-row>

        <tidy-row class="extra-top-padding">
          <tidy-datepicker
            [label]="'Offer expires (optional)'"
            [icon]="'assets/svg/calendar.svg'"
            formControlName="expiresAt"
            [form]="form.controls.expiresAt"
            [noPastDates]="true"
            [submitted]="submitted" />
        </tidy-row>
      </form>

      <tidy-row class="extra-top-padding">
        <tidy-button
          [text]="'Create Link'"
          [action]="save"
          class="primary"
          [disabled]="isSaving" />
      </tidy-row>
    }

    @if (!isLoading && config && link) {
      <tidy-card>
        <tidy-row class="vertical-align-center">
          <tidy-image
            [src]="'assets/svg/link-outline.svg'"
            class="header-size" />
          <tidy-text [header]="'Your booking link'" />
        </tidy-row>
        <tidy-row class="vertical-align-center extra-top-padding">
          <tidy-text [body]="link" [translate]="false" />
          <tidy-image
            [src]="'assets/svg/copy-outline.svg'"
            class="body-size margin-left-5 clickable"
            (action)="copyLink()" />
        </tidy-row>
        <tidy-row class="extra-top-padding">
          <tidy-text [helper]="'Share it with your guest. Booking it charges their card immediately.'" />
        </tidy-row>
      </tidy-card>

      <tidy-row class="extra-top-padding">
        <tidy-button
          [text]="'Done'"
          [action]="done"
          class="primary" />
      </tidy-row>
    }

    @if (!isLoading && !config) {
      <tidy-alert>
        <tidy-row>
          <tidy-text [body]="'No site configuration found.'" />
        </tidy-row>
      </tidy-alert>
    }
  </tidy-wrapper>
</ng-template>

@if (windowService.isDesktopRes) {
  <ng-container *ngTemplateOutlet="content" />
} @else {
  <app-scroll-wrapper [templateContent]="content" />
}
